import FeatureIntroductionListPage from "./pages/FeatureIntroductionListPage";
import FeatureIntroductionCreatePage from "./pages/FeatureIntroductionCreatePage";

export const featureIntroductionRoutes = (prefix = "feature-introduction") => [
  {
    name: "FeatureIntroductionListPage",
    path: prefix,
    component: FeatureIntroductionListPage
  },
  {
    name: "FeatureIntroductionCreatePage",
    path: `${prefix}/create`,
    component: FeatureIntroductionCreatePage
  }
];
